import React from "react";
import { IonSpinner, IonLabel } from "@ionic/react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import MonthYearPicker from "../../../components/MonthYearPicker";
import BranchSelect from "../../../components/BranchSelect";

const Header = (props) => {
  const { loading } = props;
  const intl = useIntl();
  const name = useSelector((state) => state.auth.profile.name);
  const professional_role_id = useSelector(
    (state) => state.employee.activeEmployee.professional_role_id
  );

  return (
    <div
      className="stick_to_top"
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "20px 20px 0 20px",
        }}
      >
        <div style={{ margin: "0 0 10px 0" }}>
          <IonLabel>
            {`${intl.formatMessage({
              id: "app.mobile.hello",
            })} ${name}, ${intl.formatMessage({
              id: `app.mobile.dataSelect.professional_role_id.${professional_role_id}`,
              defaultMessage: "",
            })}`}
          </IonLabel>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 12px 0 12px",
        }}
      >
        {loading ? (
          <div
            style={{
              paddingLeft: "20px",
            }}
          >
            <IonSpinner />
          </div>
        ) : (
          <MonthYearPicker />
        )}
        <BranchSelect />
      </div>
    </div>
  );
};

export default Header;
